



















import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import Loader from '@/components/Loader.vue';
import { Action } from 'vuex-class';
import moment from 'moment';

@Component({
  components: { Loader, NewTranslation, Button },
})
export default class SelectPrintModePage extends Vue {
  @Prop({ type: Object, required: false })
  public transaction!: any | null;

  @Prop({ type: Array })
  public taxcardIds!: number[];

  @Action
  public generatePrinterCode!: any;

  public printingCode: number | null = null;

  public refreshingCode: boolean = false;

  public async created(): Promise<void> {
    if (!this.transaction) {
      return;
    }
    await this.refreshAndSetCode();
  }

  public async refreshAndSetCode(): Promise<void> {
    this.refreshingCode = true;
    try {
      this.printingCode = await this.generatePrinterCode({
        transactionId: this.transaction.id,
        taxcardIds: this.taxcardIds,
      });
    } catch (e) {
      this.showInfo('Failed', 'Something went wrong. Please try agaîn later');
      this.close();
    } finally {
      this.refreshingCode = false;
    }
  }

  @Emit()
  public close(): void {}

  public submit(): void {}

  public date(date: any): any {
    return moment(date);
  }

  public showInfo(title: string, message: string, submit?: () => void): void {
    const overlayData: any = {
      title,
      message,
    };

    if (submit) {
      overlayData.submit = submit;
    }

    this.$store.commit('openOverlay', {
      overlayName: 'Info',
      overlayData: overlayData,
    });
  }
}
